__turbopack_context__.v({
  "root": "_2GWW3G_root",
});
